<template>
    <div class="mb20">
        <div class="col-md-12 table-title">
            <div v-if="order.order.isStockCheckOnly">
                確認依頼日：{{ dateFormat(order.createdAt, 'YYYY/MM/DD(ddd)') }}
            </div>
            <div v-else>
                利用日：{{ dateFormat(order.order.usageDate, 'YYYY/MM/DD(ddd)') }}
            </div>
            <user-order-status
                v-if="order.latestOrderHistory.id"
                class="mr-auto ml15"
                style="max-height: 37px"
                :status="order.latestOrderHistory.status"
            />
            <div class="order-data">注文番号：{{ order.orderNumber }}</div>
            <div style="width: 100%;">
                {{ order.order.usageNameText }}
                <a v-if="order.order.usageDetail" style="color: #5e5e65;">：{{ order.order.usageDetail}}</a>
            </div>
            <div class="order-data pc-none">合計：￥{{ order.order.fixTotalPrice }}</div>
        </div>
        <div class="order-list" style="width: 100%;">
            <table
                class="table order-history-table"
                :class="{ active: isAccordion }"
            >
                <tbody style="border: none">
                <tr
                    v-for="(orderItem, i) in order.order.orderItems"
                    :key="i"
                >
                    <order-product-item :order-item="orderItem" />
                </tr>
                <tr
                    v-if="order.latestOrderHistory.id"
                    v-for="(orderNotListItem, i) in order.latestOrderHistory.orderNotListItems"
                    :key="orderNotListItem.id"
                >
                    <order-product-not-list-item :order-not-list-item="orderNotListItem" />
                </tr>
                </tbody>
            </table>
            <div class="history-footer">
                <div class="price sp-none">合計：￥{{ order.order.fixTotalPrice }}</div>
                <div style="display: flex">
                    <button
                        v-if="
                             order.latestOrderHistory.status ===
                             OrderConstant.ORDER_STATUS_COMPLETE
                        "
                        class="btn mr20 re-order-btn"
                        v-btn-loading="busy"
                        @click="reOrder()"
                    >
                        再オーダーする
                    </button>
                    <button
                        v-if="order.latestOrderHistory.id"
                        class="btn btn-primary white"
                        @click="goDetail"
                    >
                        詳細を見る
                    </button>
                </div>
            </div>
        </div>

        <div v-if="TotalCount > 1">
            <button
                class="order-history-btn"
                @click="isAccordion = !isAccordion"
                v-if="!isAccordion"
            >
                すべて見る<i class="fa fa-angle-down"></i>
            </button>
            <button
                v-else
                class="order-history-btn"
                @click="isAccordion = !isAccordion"
            >
                閉じる<i class="fa fa-angle-up"></i>
            </button>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import Order from '../../models/Order'
import BtnLoading from '../../directives/BtnLoading.vue'
import UserOrderStatus from '../order/UserOrderStatus'
import OrderProductItem from '../order/OrderProductItem.vue'
import OrderProductNotListItem from '../order/OrderProductNotListItem.vue'
import OrderConstant from '../../const/OrderConstant'
import { dateFormat } from '../../utility/dateUtility'

export default {
    name: 'order-history',
    components: { OrderProductNotListItem, OrderProductItem, UserOrderStatus },
    data() {
        return {
            busy: false,
            isAccordion: false,
            dateFormat,
        }
    },
    props: {
        order: {
            type: Order,
        },
    },
    computed: {
        OrderConstant() {
            return OrderConstant
        },
        TotalCount() {
            return this.order.latestOrderHistory.orderItems.length + this.order.latestOrderHistory.orderNotListItems.length
        }
    },
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY年MM月DD日')
        },
    },
    methods: {
        async reOrder() {
            this.busy = true
            const arr = this.order.order.orderItems.map((x) => x.getPostable())
            await axios.post('/api/cart/add', arr)
            window.location.href = '/cart'
            this.busy = false
        },
        goDetail() {
            window.location.href = `/mypage/order/detail/${this.order.encryptCode}`
        },
    },
    directives: {
        BtnLoading,
    },
}
</script>

<style lang="scss" scoped>
@import '../../../sass/_common.scss';

.order-list {
    display: flex;
    border: 1px solid #ddd;
    border-top: none;
    @include mq() {
        display: block;
    }
}

.history-footer {
    display: flex;
    text-align: right;
    align-items: flex-end;
    flex-direction: column;
    justify-content: flex-end;
    padding: 15px;

    .price {
        font-size: 20px;
        margin-bottom: 15px;
        font-weight: bold;
        color: #262634;
        white-space: nowrap;
    }

    .re-order-btn {
        color: #000;
        background-color: #fff;
        border-color: #a4abae;

        &:hover {
            color: #fff;
            background-color: #000;
        }
    }

    @include mq() {
        justify-content: flex-end;
        border-top: 1px solid #ddd;
        .re-order-btn {
            background-color: #a4abae;
            color: #fff;
        }
    }
}

table.order-history-table {
    &.active {
        tbody > tr:nth-child(1) > td {
            @include mq() {
                padding-bottom: unset;
            }
        }

        tr:nth-child(n + 2) {
            display: table-row;
        }

        tbody > tr:last-child > td {
            margin-bottom: 30px;
        }
    }

    &.table tbody > tr:first-child > td {
        padding-bottom: 30px;
    }

    & tr:nth-child(n + 2) {
        display: none;
    }

    &.active > .order-history-btn {
        i {
            transform: rotate(180deg);
        }
    }
}

#order_history {
    .sp-break {
        display: none;
        @media screen and (max-width: 576px) {
            display: block;
        }
    }

    .table-title {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding: 13px;
        background-color: #f9f9f9;
        border: 1px solid #ddd;
        border-bottom: 0;
        font-size: 16px;
        font-weight: bold;
        @media screen and (max-width: 768px) {
            font-size: 13px;
        }

        .order-data {
            @include mq() {
                width: 100%;
            }
        }
    }
}

.order-history-btn {
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    border-top: 0;
    color: #909090;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/mypage/OrderHistory.vue